"use client";

import { useEffect } from "react";

import { newrelic } from "@jti/fe-clients";

import { getDeviceAttributes } from "./collectors/getDeviceAttributes";
import { getNetworkAttributes } from "./collectors/getNetworkAttributes";

const isAgentEnabled = () => process.env.NEXT_PUBLIC_NEW_RELIC_ENABLED === "1";

const POLL_INTERVAL_MS = 50;
const MAX_ATTEMPTS = 40;

const whenNewRelicReady = (onReady: () => void): (() => void) => {
  let attempts = 0;
  let cancelled = false;

  const tick = () => {
    if (cancelled) {
      return;
    }
    if (newrelic.isReady()) {
      onReady();
      return;
    }
    attempts += 1;
    if (attempts >= MAX_ATTEMPTS) {
      return;
    }
    timeoutId = window.setTimeout(tick, POLL_INTERVAL_MS);
  };

  let timeoutId = window.setTimeout(tick, POLL_INTERVAL_MS);

  return () => {
    cancelled = true;
    window.clearTimeout(timeoutId);
  };
};

export const NewrelicCustomAttributes = () => {
  useEffect(() => {
    if (!isAgentEnabled()) {
      return;
    }

    const cancel = whenNewRelicReady(() => {
      newrelic.setCustomAttributes({
        ...getDeviceAttributes(),
        ...getNetworkAttributes(),
      });
    });

    return cancel;
  }, []);

  return null;
};
